var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"custom-footer"}},[_c('span',{staticClass:"mr-4"},[_vm._v("© 2021 RateRabbit, Inc.")]),_c('span',{staticClass:"mr-4"},[_vm._v("Privacy")]),_c('span',[_vm._v("Terms of Service")])])
}]

export { render, staticRenderFns }